interface CarouselControlsProps {
  onPrevious: () => void;
  onNext: () => void;
  onTogglePause: () => void;
  isTransitioning: boolean;
  isManuallyPaused: boolean;
  currentIndex: number;
  totalImages: number;
}

export const CarouselControls = ({
  onPrevious,
  onNext,
  onTogglePause,
  isTransitioning,
  isManuallyPaused,
  currentIndex,
  totalImages,
}: CarouselControlsProps) => {
  return (
    <>
      {/* Left Arrow Navigation */}
      <button
        onClick={onPrevious}
        disabled={isTransitioning}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 active:bg-black/80 disabled:opacity-50 disabled:cursor-not-allowed text-white p-3 md:p-2 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/50 touch-manipulation"
        style={{ minWidth: '44px', minHeight: '44px' }} // Ensure minimum touch target size
        aria-label={`Previous image. Currently showing image ${currentIndex + 1} of ${totalImages}`}
        title="Previous image (Left arrow key)"
      >
        <svg
          className="w-6 h-6 md:w-5 md:h-5 lg:w-6 lg:h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      {/* Right Arrow Navigation */}
      <button
        onClick={onNext}
        disabled={isTransitioning}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 active:bg-black/80 disabled:opacity-50 disabled:cursor-not-allowed text-white p-3 md:p-2 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/50 touch-manipulation"
        style={{ minWidth: '44px', minHeight: '44px' }} // Ensure minimum touch target size
        aria-label={`Next image. Currently showing image ${currentIndex + 1} of ${totalImages}`}
        title="Next image (Right arrow key)"
      >
        <svg
          className="w-6 h-6 md:w-5 md:h-5 lg:w-6 lg:h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </button>

      {/* Pause/Play Button */}
      <button
        onClick={onTogglePause}
        className="absolute top-2 right-2 bg-black/50 hover:bg-black/70 active:bg-black/80 text-white p-2 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-white/50 touch-manipulation"
        style={{ minWidth: '44px', minHeight: '44px' }}
        aria-label={isManuallyPaused ? 'Resume carousel auto-advance' : 'Pause carousel auto-advance'}
        title={isManuallyPaused ? 'Resume carousel (Spacebar)' : 'Pause carousel (Spacebar)'}
      >
        {isManuallyPaused ? (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
          </svg>
        ) : (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
          </svg>
        )}
      </button>
    </>
  );
};